import { create } from 'zustand';

export type ThemeMode = 'dark' | 'light' | 'system';

export interface OrgThemeConfig {
  primary_color?: string | null;
  secondary_color?: string | null;
  logo_url?: string | null;
  status_overrides?: Record<string, string> | null;
}

interface ThemeState {
  mode: ThemeMode;
  resolvedMode: 'dark' | 'light';
  orgTheme: OrgThemeConfig | null;

  setMode: (mode: ThemeMode) => void;
  setOrgTheme: (theme: OrgThemeConfig | null) => void;
  toggleMode: () => void;
}

function resolveMode(mode: ThemeMode): 'dark' | 'light' {
  if (mode !== 'system') return mode;
  if (typeof window === 'undefined') return 'dark';
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

function getInitialMode(): ThemeMode {
  if (typeof window === 'undefined') return 'dark';
  return (localStorage.getItem('quazi-theme-mode') as ThemeMode) || 'dark';
}

const initialMode = getInitialMode();

export const useThemeStore = create<ThemeState>((set, get) => ({
  mode: initialMode,
  resolvedMode: resolveMode(initialMode),
  orgTheme: null,

  setMode: (mode) => {
    localStorage.setItem('quazi-theme-mode', mode);
    set({ mode, resolvedMode: resolveMode(mode) });
  },

  setOrgTheme: (theme) => set({ orgTheme: theme }),

  toggleMode: () => {
    const current = get().resolvedMode;
    const next = current === 'dark' ? 'light' : 'dark';
    localStorage.setItem('quazi-theme-mode', next);
    set({ mode: next, resolvedMode: next });
  },
}));
